/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import { defaultLanguage } from '../../../../config/prismic';

import { propTypesCategory } from '../../../templates/Category/Category.proptypes';
import { propTypesHomepage } from '../../../templates/Homepage/Homepage.proptypes';
import { propTypesPage } from '../../../templates/Page/Page.proptypes';
import { propTypesTag } from '../../../templates/Tag/Tag.proptypes';

import Breadcrumb from '../../../ui/Atoms/Breadcrumb';

import { getParentsData } from '../../utils/getParentsData';

import { DocumentType } from '../../constants/Enums';
import * as S from './BreadcrumbSection.styles';

const BlogPageTypes = [
  DocumentType.CATEGORY,
  DocumentType.TAG,
  DocumentType.POST,
  DocumentType.TESTIMONIAL,
  DocumentType.RESOURCE,
  DocumentType.NEWSLETTER,
  DocumentType.WOOBINAR,
];

const WebsitePageTypes = [
  DocumentType.PAGE,
  DocumentType.CONTACT,
  DocumentType.PRICING,
  DocumentType.EVENTGALLERY,
  DocumentType.EVENTTAG,
  DocumentType.EVENT,
  DocumentType.QUOTEGENERATOR,
  DocumentType.GLOSSARY,
  DocumentType.DEFINITION,
];

const getHomepageUrlFromDocumentType = ({ documentType, currentLanguage }) => {
  if (BlogPageTypes.includes(documentType)) {
    return `/${currentLanguage.slice(0, 2)}/blog/`;
  }

  if (WebsitePageTypes.includes(documentType)) {
    return currentLanguage === defaultLanguage
      ? `/`
      : `/${currentLanguage.slice(0, 2)}/`;
  }
};

const getUrlFromLang = ({ currentLanguage, url, isBlogPage }) => {
  if (isBlogPage) {
    return `/${currentLanguage.slice(0, 2)}/blog/${url}/`;
  }

  return `/${currentLanguage.slice(0, 2)}/${url}/`;
};

export const BreadcrumbSection = ({
  currentLanguage,
  currentPageName,
  homepage,
  parentPages,
  prismicDocumentType,
  parentPage,
}) => {
  if (
    !homepage ||
    !prismicDocumentType ||
    !currentLanguage ||
    !currentPageName
  ) {
    return null;
  }

  const homepageName = homepage.data?.homepage_name || '';
  const homepageUrl = getHomepageUrlFromDocumentType({
    documentType: prismicDocumentType,
    currentLanguage,
  });

  const parentList = [];

  if (parentPages?.length >= 1) {
    const givenParentPages = getParentsData({ parentList: parentPages });

    givenParentPages.map(givenParentPage => parentList.push(givenParentPage));
  }

  if (parentPage) {
    parentList.push(parentPage);
  }

  const breadcrumbParentList = [];

  if (parentList.length >= 1) {
    const isBlogPage = homepageUrl?.includes('/blog') || false;

    parentList.map(parent =>
      breadcrumbParentList.push({
        parentUid: getUrlFromLang({
          currentLanguage,
          url: parent?.parentUid,
          isBlogPage,
        }),
        parentName: parent?.parentName,
      })
    );
  }

  return (
    <S.Wrapper>
      <Breadcrumb
        currentPageName={currentPageName}
        homepageName={homepageName}
        homepageUrl={homepageUrl}
        parentList={breadcrumbParentList}
      />
    </S.Wrapper>
  );
};

BreadcrumbSection.propTypes = {
  currentLanguage: PropTypes.string.isRequired,
  currentPageName: PropTypes.string.isRequired,
  homepage: PropTypes.shape(propTypesHomepage).isRequired,
  parentPage: PropTypes.shape(
    PropTypes.oneOfType([
      PropTypes.shape(propTypesTag),
      PropTypes.shape(propTypesCategory),
    ])
  ),
  parentPages: PropTypes.arrayOf(
    PropTypes.shape({
      parent_document: PropTypes.shape({
        document: PropTypes.shape(propTypesPage),
      }),
      parent_name: PropTypes.string,
    })
  ),
  prismicDocumentType: PropTypes.string.isRequired,
};
